module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-chat-window",
    class: {
      opened: _vm.isOpen, closed: !_vm.isOpen
    }
  }, [_c('ListUsers', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.escolheuCliente),
      expression: "!escolheuCliente"
    }],
    attrs: {
      "clientes": _vm.mensagens
    },
    on: {
      "selectedCliente": _vm.selectedCliente,
      "atualizarImagem": _vm.atualizarImagem
    }
  }), _vm._v(" "), (_vm.escolheuCliente) ? _c('Header', {
    attrs: {
      "teamName": _vm.clienteEscolhido.nome,
      "imageUrl": _vm.clienteEscolhido.img,
      "onClose": _vm.onClose
    },
    on: {
      "back": _vm.backChat
    }
  }) : _vm._e(), _vm._v(" "), (_vm.escolheuCliente) ? _c('MessageList', {
    attrs: {
      "messages": _vm.messageList,
      "imageUrl": _vm.clienteEscolhido.img,
      "chatImageUrl": _vm.clienteEscolhido.img
    }
  }) : _vm._e(), _vm._v(" "), _c('UserInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.escolheuCliente),
      expression: "escolheuCliente"
    }],
    attrs: {
      "showEmoji": _vm.showEmoji,
      "onSubmit": _vm.onUserInputSubmit,
      "showFile": _vm.showFile,
      "placeholder": _vm.placeholder
    },
    on: {
      "sendMsg": _vm.sendMsg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00a6d6ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-beautiful-chat/src/ChatWindow.vue
// module id = 1194
// module chunks = 1